// extracted by mini-css-extract-plugin
export default {"navList":"NavList_navList__USZIZ","active":"NavList_active__PEIMH"};